function h5Platform() {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if(isiOS){
        return 'ios'
    }else if(isAndroid){
        return 'android'
    }     
}
export {
    h5Platform
}



// WEBPACK FOOTER //
// ./src/config/common.js